import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';
import type { Company } from 'src/secret-menu/hooks/useCompanies';

type SmartCreateCompanyInput = {
  name: string;
  fca_firm_reference_number: string;
  website?: string | null;
  confirm_shared_feed_identifiers?: boolean;
};

export function useSmartCreateCompany() {
  const queryClient = useQueryClient();

  const { mutateAsync } = useMutation<{ data: Company }, Error, SmartCreateCompanyInput>({
    mutationFn: input => api.post<Company>('admin/companies', input),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin', 'companies'] });
    },
  });

  const createCompany = async (input: SmartCreateCompanyInput): Promise<string> => {
    const result = await mutateAsync(input);
    return result.data.id;
  };

  return { createCompany };
}
